
import { Component, Vue } from 'vue-property-decorator'
import SearchNav from "@/components/SearchNav/index.vue";
import GoodsResultCard from "@/views/goodsManage/mall/shop/template/GoodsResultCard.vue";
import { getShopGoodsList, ShopGoodsListDto } from "@/api/shoppingMall";
import { Getter } from "vuex-class";

@Component({
  name: 'SearchGoods',
  components: { SearchNav, GoodsResultCard }
})
export default class SearchGoods extends Vue {
  @Getter companyId!: string
  @Getter providerId!: string

  goodsList: ShopGoodsListDto[] = []
  params = {
    pageIndex: 1,
    pageSize: 20,
    shopId: '',
    customerId: '',
    keyword: ''
  }

  created () {
    this.params.keyword = this.$route.query.keyword as string
    this.params.shopId = this.providerId
    this.params.customerId = this.companyId
    this.getGoodsList(this.params.keyword)
  }

  getGoodsList (keyword: string) {
    this.params.keyword = keyword
    getShopGoodsList(this.params).then((res) => {
      this.goodsList = res.data.records || []
    })
  }

  reloadList () {
    this.params.pageIndex = 1
    this.getGoodsList(this.params.keyword)
  }

  searchFunc (keyword: string) {
    this.params.keyword = keyword
    this.params.pageIndex = 1
    this.getGoodsList(keyword)
  }

}
